import React, { useContext } from "react";
import { MenuMobileContext } from "../contexts/MenuMobileContext";

function useMenuMobile() {
  const context = useContext(MenuMobileContext);

  return context;
}

export { useMenuMobile };
